import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { TramitePensionHomeComponent } from "./pages/tramite-pension-home/tramite-pension-home.component";
import { TramitePensionRequestComponent } from "./pages/tramite-pension-request/tramite-pension-request.component";
import { VideoatencionComponent } from "./pages/video-atencion/video-atencion.component";
import { VoucherPensionComponent } from "./pages/voucher-pension/voucher-pension.component";
import { RequestErrorComponent } from "./pages/request-error/request-error.component";
import {
  REQUEST_ERROR,
  ROUTING_TRAMITE_PENSION,
  VIDEO_ATENCION,
  VOUCHER_PENSION,
} from "@constants/url.constant";
import { PersonalDataComponent } from "./pages/personal-data/personal-data.component";
import { DocumentUploadComponent } from "./pages/document-upload/document-upload.component";
import { ConfirmDataComponent } from "./pages/confirm-data/confirm-data.component";
import { loadRemoteModule } from "@angular-architects/module-federation";
import { environment } from '../../environments/environment';
import { TramitePensionSeguridadComponent } from "./pages/tramite-pension-seguridad/tramite-pension-seguridad.component";
import { ViaPagoComponent } from "./pages/via-pago/via-pago.component";
import { TramitePensionAntecedentesComponent } from "./pages/tramite-pension-antecedentes/tramite-pension-antecedentes.component";

const TRAMITE_PENSION_ROUTES: Routes = [
  {
    path: "",
    component: TramitePensionHomeComponent,
    pathMatch: "full",
    data: { gtm: { event_name: 'tramite_pension', paso_numero: '0', paso_nombre: 'inicio_solicitud' } }
  },
  {
    path: ROUTING_TRAMITE_PENSION.BASE_URL,
    component: TramitePensionHomeComponent,
    data: { gtm: { event_name: 'tramite_pension', paso_numero: '0', paso_nombre: 'inicio_solicitud' } }
  },
  {
    path: ROUTING_TRAMITE_PENSION.REQUEST,
    component: TramitePensionRequestComponent,
    children: [
      {
        path: "",
        redirectTo: ROUTING_TRAMITE_PENSION.SEGURIDAD,
        pathMatch: "full",
      },
      {
        //canActivate: [StepsGuard],
        //data: { currentStep: 2 },
        path: ROUTING_TRAMITE_PENSION.SEGURIDAD,
        component: TramitePensionSeguridadComponent,
        data: { gtm: { event_name: 'tramite_pension', paso_numero: '1', paso_nombre: 'modulo_validacion' } },
        loadChildren: () =>
          loadRemoteModule({
            type: "module",
            remoteEntry: environment.SECURITY_REMOTE_ENTRY_URL,
            exposedModule: "./VALIDACIONES",
          }).then((m) => m.ValidacionesModule),
      },
      {
        path: ROUTING_TRAMITE_PENSION.DATOS_PERSONALES,
        component: PersonalDataComponent,
        data: { gtm: { event_name: 'tramite_pension', paso_numero: '2', paso_nombre: 'tu_informacion' } }
      },
      {
        path: ROUTING_TRAMITE_PENSION.ANTECEDENTES_PENSION,
        component: TramitePensionAntecedentesComponent,
        data: { gtm: { event_name: 'tramite_pension', paso_numero: '3', paso_nombre: 'antecedentes_pension' } }
      },
      {
        path: ROUTING_TRAMITE_PENSION.VIA_PAGO,
        component: ViaPagoComponent,
        data: { gtm: { event_name: 'tramite_pension', paso_numero: '4', paso_nombre: 'via_de_pago' } }
      },
      {
        path: ROUTING_TRAMITE_PENSION.CARGA_DOCUMENTOS,
        component: DocumentUploadComponent,
        data: { gtm: { event_name: 'tramite_pension', paso_numero: '5', paso_nombre: 'documentacion' } }
      },
      {
        path: ROUTING_TRAMITE_PENSION.CONFIRMAR_DATOS,
        component: ConfirmDataComponent,
        data: { gtm: { event_name: 'tramite_pension', paso_numero: '6', paso_nombre: 'confirmacion' } }
      },
    ],
  },
  {
    path: VIDEO_ATENCION,
    component: VideoatencionComponent,
    pathMatch: "full",
  },
  {
    path: VOUCHER_PENSION,
    component: VoucherPensionComponent,
    pathMatch: "full",
    data: { gtm: { event_name: 'tramite_pension', paso_numero: '7', paso_nombre: 'comprobante' } }
  },
  {
    path: REQUEST_ERROR,
    component: RequestErrorComponent,
    pathMatch: "full",
  },
];

@NgModule({
  imports: [RouterModule.forChild(TRAMITE_PENSION_ROUTES)],
  exports: [RouterModule],
})
export class TramitePensionRoutesModule { }
